import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {
    getDeletedReceptionistDeviceDatas,
    hardDeleteReceptionistDeviceData,
    restoreReceptionistDeviceData,
} from "../../../redux/modules/ReceptionistDevice/action";

class ReceptionistDeviceTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedReceptionistDeviceDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.receptionistDevice.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const receptionistDeviceColumn = [
            {
                name: "Name",
                path: "name",
                show: true,
            },
            {
                name: "UNUM",
                path: "UNUM",
                show: true,
            },
            {
                name: "Charger Name",
                path: "charger",
                show: true,
                render: (data) => data.result.name,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"ReceptionistDevice Category Data"}
                        data={this.props.receptionistDevice.datas}
                        columns={receptionistDeviceColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteReceptionistDeviceData(id)}
                        restoreAction={(id) => this.props.restoreReceptionistDeviceData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    receptionistDevice: state.receptionistDevice,
});

const mapDispatchToProps = {
    getDeletedReceptionistDeviceDatas,
    hardDeleteReceptionistDeviceData,
    restoreReceptionistDeviceData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(ReceptionistDeviceTrash)
);
